import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWorkCulture } from "../workCultureModal";

export const getAllWorkCulture = createAsyncThunk(
  "WorkCulture/FindAllWorkCulture",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/FindAllWorkCulture`,
        {
          WorkCultureTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WorkCulture:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWorkCulture = createAsyncThunk(
  "WorkCulture/InsertWorkCulture",
  async (WorkCultureData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/InsertWorkCulture`,
        WorkCultureData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating WorkCulture:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWorkCulture = createAsyncThunk(
  "WorkCulture/UpdateWorkCulture",
  async (WorkCultureData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/UpdateWorkCulture`,
        WorkCultureData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating WorkCulture:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWorkCulture = createAsyncThunk(
  "WorkCulture/DeleteWorkCulture",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/DeleteWorkCulture`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting WorkCulture :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWorkCultureByID = createAsyncThunk(
  "WorkCulture/FindByIDWorkCulture",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/FindByIDWorkCulture`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceID: result.ServiceID ? +result.ServiceID : "",
        Title: result.Title ? result.Title : "",
        Subtitle: result.Subtitle ? result.Subtitle : "",
        Description: result.Description ? result.Description : "",
        IsActive: result.IsActive ? 1 : 2,
      } as IWorkCulture;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching WorkCulture :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWorkCulture = createAsyncThunk(
  "WorkCulture/FindAllActiveWorkCulture",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WorkCulture/FindAllActiveWorkCulture`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WorkCulture:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWorkCulture = createAsyncThunk(
  "WorkCulture/ActiveInActiveWorkCulture",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/ActiveInActiveWorkCulture`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive WorkCulture :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const WorkCultureDetailsImageUpload = createAsyncThunk(
  "WorkCulture/WorkCultureImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WorkCulture/WorkCultureImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload WorkCulture Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
